module.exports = __webpack_public_path__ + "img/1-5.d1bfaabc.svg";